<!-- Initial loading (contacts not yet loaded) -->
<ng-container *ngIf="!ready">
  <div class="bl-initial-loading">
    <div class="bl-loading-dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">
<div class="bl-page">

  <!-- ── HEADER ────────────────────────────────────────────── -->
  <div class="bl-header">
    <div class="bl-header__icon"><mat-icon>lock</mat-icon></div>
    <div class="bl-header__info">
      <h1 class="bl-header__title">Nueva Fianza</h1>
      <p class="bl-header__sub">Registra una nueva garantía de proveedor</p>
    </div>
    <span class="bl-header__spacer"></span>
    <mat-icon *ngIf="saved" class="bl-saved-icon">done</mat-icon>
    <button mat-flat-button class="bl-btn-save" (click)="save(bail)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <!-- ── BODY ──────────────────────────────────────────────── -->
  <div class="bl-body">

    <!-- Spinner overlay (mid-save) -->
    <ng-container *ngIf="spinner">
      <div class="bl-spinner-overlay">
        <div class="bl-loading-dots"><span></span><span></span><span></span></div>
      </div>
    </ng-container>

    <form onkeypress="return event.keyCode != 13;">

      <!-- Top 2-col grid -->
      <div class="bl-top-grid">

        <!-- Left: Proveedor + Datos -->
        <div class="bl-col">

          <div class="bl-section">
            <div class="bl-section__head">
              <mat-icon>business</mat-icon>
              <span>Proveedor</span>
            </div>
            <div class="bl-section__body">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Proveedor</mat-label>
                <mat-icon matPrefix>business</mat-icon>
                <input matInput [(ngModel)]="bail.providerName"
                  placeholder="Buscar proveedor..."
                  [matAutocomplete]="autoAP" [formControl]="bailForm" required>
                <mat-autocomplete #autoAP="matAutocomplete">
                  <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                    {{ contact.companyName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>

          <div class="bl-section">
            <div class="bl-section__head">
              <mat-icon>date_range</mat-icon>
              <span>Datos</span>
            </div>
            <div class="bl-section__body">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Duración</mat-label>
                <mat-select [(ngModel)]="bail.duration" name="duration" required>
                  <mat-option [value]="1">Corto Plazo - 565</mat-option>
                  <mat-option [value]="2">Largo Plazo - 260</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha</mat-label>
                <mat-icon matPrefix>event</mat-icon>
                <input matInput [matDatepicker]="bailDatePicker"
                  [(ngModel)]="bail.date" name="bail.date" required>
                <mat-datepicker-toggle matSuffix [for]="bailDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #bailDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

        </div>

        <!-- Right: Pago -->
        <div class="bl-col">
          <div class="bl-section">
            <div class="bl-section__head">
              <mat-icon>credit_card</mat-icon>
              <span>Pago</span>
            </div>
            <div class="bl-section__body">
              <app-select [(ngModel)]="bail.typePay" name="bail.typePay"
                [config]="{ label: 'Tipo de pago', placeholder: 'Seleccionar', required: true, options: payMethodsOptions }">
              </app-select>

              <ng-container *ngIf="bail.typePay === 'Efectivo'">
                <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="bail.efectivoId"
                  [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja/Efectivo">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="bail.typePay === 'Socio'">
                <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="bail.partnersId"
                  [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socios">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="bail.typePay === 'Transferencia bancaria'
                  || bail.typePay === 'Cargo en cuenta'
                  || bail.typePay === 'Confirming'
                  || bail.typePay === 'Pagarés'">
                <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="bail.typePayBankAccount"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="bail.typePay === 'Tarjeta de crédito'">
                <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="bail.typePayBankAccount"
                  [idField]="'uid'" [displayFields]="['name', 'number']" placeholder="Tarjetas de crédito">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="bail.typePay === 'Tarjeta de débito'">
                <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="bail.typePayBankAccount"
                  [idField]="'uid'" [displayFields]="['name', 'number']" placeholder="Tarjetas de débito">
                </app-autocomplete-select>
              </ng-container>
            </div>
          </div>
        </div>

      </div>

      <!-- Lines section -->
      <div class="bl-section">
        <div class="bl-section__head">
          <mat-icon>list</mat-icon>
          <span>Líneas de fianza</span>
          <span class="bl-section__badge" *ngIf="bail.bailLine?.length">{{ bail.bailLine.length }}</span>
          <span class="bl-lines-spacer"></span>
          <button mat-stroked-button type="button" (click)="addInvoiceLine()" class="bl-btn-add">
            <mat-icon>add</mat-icon> Añadir concepto
          </button>
        </div>
        <div class="bl-section__body bl-section__body--no-pad">

          <div class="bl-empty-lines" *ngIf="!bail.bailLine?.length">
            <mat-icon>inbox</mat-icon>
            <p>Sin conceptos. Pulsa "Añadir concepto" para comenzar.</p>
          </div>

          <div class="bl-table-wrap" *ngIf="bail.bailLine?.length">
            <table mat-table [dataSource]="bail.bailLine" class="bl-lines-table w-100">

              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>Concepto</th>
                <td mat-cell *matCellDef="let item">{{ item.product }}</td>
              </ng-container>

              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Unidades</th>
                <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
              </ng-container>

              <ng-container matColumnDef="unityAmount">
                <th mat-header-cell *matHeaderCellDef>Precio</th>
                <td mat-cell *matCellDef="let item">{{ item.unityAmount }}</td>
              </ng-container>

              <ng-container matColumnDef="discount">
                <th mat-header-cell *matHeaderCellDef>Dto. (%)</th>
                <td mat-cell *matCellDef="let item">{{ item.discount }}</td>
              </ng-container>

              <ng-container matColumnDef="taxes">
                <th mat-header-cell *matHeaderCellDef>Impuestos</th>
                <td mat-cell *matCellDef="let item">{{ getStrTaxes(item.taxes) }}</td>
              </ng-container>

              <ng-container matColumnDef="totalLine">
                <th mat-header-cell *matHeaderCellDef class="bl-th-right">Total</th>
                <td mat-cell *matCellDef="let item" class="bl-td-right bl-td-total">{{ calcularTotalesLinea(item) }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item; index as i" class="bl-td-actions">
                  <button mat-icon-button type="button" (click)="toggleEditMode(i)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button type="button" (click)="removeInvoiceLine(item)" matTooltip="Eliminar" color="warn">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="blColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: blColumns;"></tr>

            </table>
          </div>

          <!-- Totals -->
          <div class="bl-totals" *ngIf="bail.bailLine?.length">
            <div class="bl-totals__row">
              <span class="bl-totals__lbl">Subtotal</span>
              <span class="bl-totals__val">{{ calcularSubtotal() }}</span>
            </div>
            <div class="bl-totals__row bl-totals__row--tax" *ngFor="let taxLine of impuestos(); trackBy: trackByIndex">
              <span class="bl-totals__tax">{{ taxLine }}</span>
            </div>
            <div class="bl-totals__row bl-totals__row--grand">
              <span class="bl-totals__lbl bl-totals__lbl--bold">Total</span>
              <span class="bl-totals__val bl-totals__val--bold">{{ calcularTotal() }}</span>
            </div>
          </div>

        </div>
      </div>

    </form>
  </div>

</div>
</ng-container>
